import React from 'react';
import { useMeasure } from 'react-use';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
import withSettings from 'containers/SettingsProvider/withSettings';
import Candlestick from './Candlestick';
import CustomTooltip from './CustomTooltip';
import messages from '../messages';

function CandlestickChart(props) {
  const { data, units, intl } = props;
  const [ref, { width }] = useMeasure();

  const yLabel = {
    value: `${units}/${intl.formatMessage(messages.hr)}`,
    angle: -90,
    position: 'insideLeft',
    offset: 20,
  };

  return (
    <div ref={ref} className="my-4">
      <BarChart width={width} height={200} barSize={20} data={data}>
        <XAxis dataKey="distance" />
        <YAxis label={yLabel} />
        <CartesianGrid strokeDasharray="3 3" />
        <Tooltip content={<CustomTooltip />} animationDuration={250} />
        <Bar dataKey="speeds" shape={<Candlestick />} />
      </BarChart>
      <div className="font-italic">
        <FormattedMessage {...messages.distanceTitle} />
      </div>
    </div>
  );
}

CandlestickChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      distance: PropTypes.string.isRequired,
      speeds: PropTypes.arrayOf(PropTypes.number).isRequired,
    }),
  ).isRequired,
  units: PropTypes.string.isRequired,
  intl: intlShape,
};

export default compose(
  injectIntl,
  withSettings(['units']),
)(CandlestickChart);
